module.exports = "<ag-memo-list\n  [service]=\"jobApiService\"\n  [referenceId]=\"jobId\"\n  newText=\"新規求人メモ作成\"\n  title=\"\"\n></ag-memo-list>\n"